import Table from "components/Table/Table";
import ProductRow from "./ProductRow";
import scss from "./CartTable.module.scss";
import { useTranslation } from "react-i18next";

const CartTable = ({ items, translateKey }) => {
    const { t } = useTranslation();

    return (
        <div className={scss.tableWrap}>
            <Table>
                <thead>
                    <tr>
                        <th className={scss.tcCode}>{t(`${translateKey}-table_th-code`)}</th>
                        <th className={scss.tcTitle}>{t(`${translateKey}-table_th-title`)}</th>
                        <th>{t(`${translateKey}-table_th-base_price`)}</th>
                        <th>{t(`${translateKey}-table_th-rebate`)}</th>
                        <th>{t(`${translateKey}-table_th-discount`)}</th>
                        <th>{t(`${translateKey}-table_th-price_excluding_vat`)}</th>
                        <th className={scss.tcInt}>{t(`${translateKey}-table_th-quantity`)}</th>
                        <th>{t(`${translateKey}-table_th-total_excluding_vat`)}</th>
                        <th className={scss.tcActions} aria-label={t("global-default-text-Actions", { defaultValue: "Akcije" })} />
                    </tr>
                </thead>
                <tbody>
                    {items.map((item) => (
                        <ProductRow key={item.product.id} item={item} translateKey={translateKey} />
                    ))}
                </tbody>
            </Table>
        </div>
    );
};

export default CartTable;
